import { postRequest } from "../app/postRequest.service";

export function getIntimationDetails(request: any) {
    return new Promise<{ data: any }>((resolve) =>
      resolve(postRequest('/claim/search/intimation', request))
    );
  }